import { getMessaging, isSupported } from "firebase/messaging";
import { initApp } from "~/lib/firebase/firebase.client";

// Lazily resolve it so importing this module never throws on insecure origins.
export const messaging = (async () => {
  if (typeof window === "undefined") return null;
  if (!window.isSecureContext) return null;
  const supported = await isSupported();
  if (!supported) return null;
  return getMessaging(initApp());
})();
